import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PrivilegeService } from 'api';
import isNorwegian from 'utils/language/isNorwegian';
export default function useActivateAccess() {
  const [isLoading, setIsLoading] = useState(false);
  const {
    t,
    i18n
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const activateAccess = async email => {
    try {
      setIsLoading(true);
      await PrivilegeService.grantPrivilegesByEmail({
        body: {
          email,
          isNorwegian: isNorwegian(i18n)
        }
      });
      enqueueSnackbar(t('privileges.activate_access_success'), {
        variant: 'success'
      });
    } catch (error) {
      enqueueSnackbar(t('error.something'), {
        variant: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    activateAccess
  };
}